import store from "@/store";
import { $loaderService } from "@/plugins/ELoaderService";

const redirecionarSeForProfessor = async (to, from, next) => {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await $loaderService.loadBasicDataIfNeeded();
  }

  currentUser = store.getters["Auth/user"];
  // eslint-disable-next-line
  if (!currentUser) {
    next({ name: "login" });
    return true; // Indica que houve redirecionamento
  }
  if (currentUser.roleName === "professor") {
    // Evita redirecionamento se já está na rota correta
    if (to.name === "acessoProfessor.home") {
      return false;
    }
    next({ name: "acessoProfessor.home" });
    return true; // Indica que houve redirecionamento
  }
  return false; // Não houve redirecionamento
};

export default redirecionarSeForProfessor;
